import { useCallback, useSyncExternalStore } from "react";

/** Tailwind's default `lg` breakpoint: the basic venue page's desktop layout. */
export const DESKTOP_LAYOUT_QUERY = "(min-width: 1024px)";
/** Tailwind's default `md` breakpoint: the complex venue page's desktop header. */
export const MD_UP_QUERY = "(min-width: 768px)";

const notMatchingOnServer = () => false;

/**
 * Whether a CSS media query matches, rendering as "no match" on the server and
 * during hydration so both produce the same (mobile) markup.
 *
 * @param query A media query, e.g. DESKTOP_LAYOUT_QUERY.
 * @returns Whether it matches; false until after hydration.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );
  const getSnapshot = useCallback(
    () => window.matchMedia(query).matches,
    [query],
  );

  return useSyncExternalStore(subscribe, getSnapshot, notMatchingOnServer);
}
